// extracted by mini-css-extract-plugin
export default {"services":"Services_services__0Aupi","servicesContent":"Services_servicesContent__UiX5m","service":"Services_service__5uKpQ"};